var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?[_c('Loading')]:_vm._e(),_c('Sidebar'),_c('Main'),(_vm.hasError)?_c('div',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.$t('editorSessionExpired'))+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }